<template>
  <div class="login-container">
    <div class="login-main">
      <!-- 左侧固定图片区域 -->
      <div class="login-left">
        <div class="slide-item">
          <img class="slide-bg" src="../../assets/banner.jpeg" alt="banner">
          <div class="slide-text">
            <h3>核验业务管理中台</h3>
            <p>安全、稳定、高效的政务数据核验服务</p>
          </div>
        </div>
      </div>

      <!-- 右侧登录表单 -->
      <div class="login-right">
        <div class="login-card">
          <div class="login-header">
            <h2 class="system-title">机构管理中台</h2>
            <div class="sub-desc">数据管理、权限管理、用户管理等功能</div>
          </div>

          <div class="group" v-if="logintype == 1">
            
            <div class="form-group">
              <label for="qiyephone">手机号</label>
              <input
                id="qiyephone"
                v-model="qiyephone"
                type="text"
                placeholder="请输入手机号"
                class="form-input"
                autocomplete="off"
              />
            </div>
            
            <div class="form-group">
              <label for="password">密码</label>
              <input
                id="password"
                v-model="qiyemima"
                type="password"
                placeholder="请输入密码"
                class="form-input"
                autocomplete="current-password"
              />
            </div>
            <div class="form-group code-row">
              <label for="qiyecode">短信验证码</label>
              <div class="code-wrap">
                <input
                  id="qiyecode"
                  v-model="qiyecode"
                  type="text"
                  placeholder="请输入验证码"
                  class="form-input code-input"
                  autocomplete="off"
                />
                <button
                  class="code-btn"
                  :disabled="codeDisabled || !qiyephone"
                  @click="getSmsCode"
                >
                  {{ codeText }}
                </button>
              </div>
            </div>
          </div>
          
          <div class="group" v-if="logintype == 2">
            <div class="form-group">
              <label for="iammainuser">主账号</label>
              <input
                id="iammainuser"
                v-model="iammainuser"
                type="text"
                placeholder="请输入主账号名称"
                class="form-input"
                autocomplete="username"
              />
            </div>
            <div class="form-group">
              <label for="iamuser">子账号</label>
              <input
                id="iamuser"
                v-model="iamuser"
                type="text"
                placeholder="请输入子账号名称"
                class="form-input"
                autocomplete="username"
              />
            </div>
            <div class="form-group">
              <label for="iammima">密码</label>
              <input
                id="iammima"
                v-model="iammima"
                type="password"
                placeholder="请输入登录密码"
                class="form-input"
                autocomplete="current-password"
              />
            </div>
          </div>

          <!-- 登录按钮 -->
          <button type="button" @click="login()" :disabled="isLoading" class="login-button">
            登录
          </button>

          <!-- 切换Tab -->
          <div class="tab-switch">
            <div class="tab-item" @click="switch_tab(1)" :class="{active: logintype == 1}">企业账号</div>
            <div class="divider">|</div>
            <div class="tab-item" @click="switch_tab(2)" :class="{active: logintype == 2}">IAM</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {
    ref
  } from 'vue'
  import {
    ElMessage
  } from 'element-plus'
  import router from '@/router';
  import {
    getCaptcha,qiyeLoginMain,iamLogin
  } from '@/api/api';

  // 企业变量
  const qiyephone = ref('')
  const qiyemima = ref('')
  const qiyecode = ref('')

  // IAM变量
  const iammainuser = ref()
  const iamuser = ref()
  const iammima = ref()

  //登录切换
  const logintype = ref(1)
  const switch_tab = (type) => {
    logintype.value = type
    // 切换标签清空倒计时
    codeDisabled.value = false
    codeText.value = '获取验证码'
  }

  const isLoading = ref(false)

  // 短信验证码
  const codeDisabled = ref(false)
  const codeText = ref('获取验证码')
  let timer = null

  const getSmsCode = async () => {
    const phoneReg = /^1[3-9]\d{9}$/
    if (!phoneReg.test(qiyephone.value)) {
      ElMessage.warning('请输入正确手机号')
      return
    }
    // 此处调用获取验证码接口
    const data = {
      verifyType: 'login',
      userType: 'main',
      mobileNo: qiyephone.value,
    }
    const res = await getCaptcha(data)
    console.log(res);
    if (res.code == 200) {
      ElMessage.success('验证码已发送')
    } else {
      ElMessage.error(res.message)
    }

    // 60s倒计时防抖
    codeDisabled.value = true
    let count = 60
    codeText.value = `${count}s后重新获取`
    timer = setInterval(() => {
      count--
      codeText.value = `${count}s后重新获取`
      if (count <= 0) {
        clearInterval(timer)
        codeDisabled.value = false
        codeText.value = '获取验证码'
      }
    }, 1000)
  }

  const login = async () => {
 
    if (logintype.value == 1) {
      if(!qiyephone.value){
        ElMessage.info("请输入手机号")
        return
      }
      if(!qiyemima.value){
        ElMessage.info("请输入密码")
        return
      }
      if(!qiyecode.value){
        ElMessage.info("请输入验证码")
        return
      }
      const data = {
        type:'pc',
        mobileNo: qiyephone.value,
        password: qiyemima.value,
        captcha: qiyecode.value,
      }


      const res = await qiyeLoginMain(data)
      if (res.code == 200) {
        localStorage.setItem('token', res.data.token)
        localStorage.setItem('user', JSON.stringify(res.data))
        ElMessage({
          message: '登录成功',
          type: 'success',
        })
        qiyephone.value = ''
        qiyemima.value = ''
        qiyecode.value = ''
        router.push('/userInfo')
      } else {
        ElMessage({
          message: res.message,
          type: res.error
        })
      }

    } else if (logintype.value == 2) {
      if (!iammainuser.value) {
        ElMessage.error('主账号名称不能为空！')
        return
      }
      if (!iamuser.value) {
        ElMessage.error('账号名称不能为空！')
        return
      }
      if (!iammima.value) {
        ElMessage.error('密码不能为空！')
        return
      }
      const data = {
        companyName: iammainuser.value,
        name: iamuser.value,
        password: iammima.value,
        type:'pc',
      }

      const res = await iamLogin(data)
      if (res.code == 200) {
        localStorage.setItem('token', res.data.token)
        localStorage.setItem('user', JSON.stringify(res.data))
        ElMessage({
          message: '登录成功',
          type: 'success',
        })
        iammainuser.value = ''
        iamuser.value = ''
        iammima.value = ''
        router.push('/userInfo')
      } else {
        ElMessage({
          message: res.message,
          type: res.error
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.login-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #fff;
}

.login-main {
  width: 100%;
  height: 100%;
  display: flex;
}

// 左侧图片区域
.login-left {
  flex: 1;
  position: relative;
  .slide-item {
    width: 100%;
    height: 100%;
    position: relative;
    .slide-bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    // 深色遮罩，保证文字清晰可读
    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.42);
    }
    .slide-text {
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      text-align: center;
      color: #fff;
      z-index: 2;
      h3 {
        font-size: 34px;
        font-weight: 600;
        margin-bottom: 16px;
      }
      p {
        font-size: 17px;
        opacity: 0.92;
      }
    }
  }
}

// 右侧登录表单区域
.login-right {
  width: 480px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-card {
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow:
    0 1px 2px rgba(16, 24, 40, 0.04),
    0 12px 32px -12px rgba(16, 24, 40, 0.12),
    0 32px 64px -32px rgba(43, 91, 255, 0.18);
  padding: 40px;
  animation: fadeIn 0.5s ease-in-out;
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
  .system-title {
    font-size: 24px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 6px;
  }
  .sub-desc {
    font-size: 13px;
    color: #6b7280;
  }
}

.form-group {
  margin-bottom: 20px;
  label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
  }
}

.form-input {
  width: 100%;
  height: 44px;
  padding: 0 16px;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  font-size: 14px;
  background: #f8fafc;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #2B5BFF;
    background: #ffffff;
    box-shadow: 0 0 0 3px rgba(43, 91, 255, 0.12);
  }
}

// 验证码行布局
.code-row {
  .code-wrap {
    display: flex;
    gap:10px;
    .code-input {
      flex:1;
    }
    .code-btn {
      white-space: nowrap;
      height:44px;
      padding:0 14px;
      border-radius:10px;
      border:1.5px solid #2B5BFF;
      background:#fff;
      color:#2B5BFF;
      cursor:pointer;
      transition: all 0.2s;
      &:disabled {
        background:#f3f4f6;
        border-color:#d1d5db;
        color:#9ca3af;
        cursor:not-allowed;
      }
    }
  }
}

.login-button {
  width: 100%;
  height: 46px;
  margin-top: 8px;
  font-size: 15px;
  font-weight: 500;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #2B5BFF 0%, #4E6BFF 100%);
  color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px -6px rgba(43, 91, 255, 0.45);
  }
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.tab-switch {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  gap: 12px;
  .tab-item {
    font-size: 14px;
    color: #9ca3af;
    cursor: pointer;
    transition: color 0.2s;
    &.active {
      color: #2B5BFF;
      font-weight: 500;
    }
  }
  .divider {
    color: #d1d5db;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 移动端适配：小屏幕自动上下布局
@media (max-width: 992px) {
  .login-main {
    flex-direction: column;
  }
  .login-left {
    height: 320px;
    flex: none;
  }
  .login-right {
    width: 100%;
    flex: 1;
  }
}
@media (max-width: 480px) {
  .login-card {
    padding: 28px 24px;
  }
  .system-title {
    font-size: 20px;
  }
  .form-input {
    height: 42px;
  }
  .login-button {
    height: 44px;
  }
}
</style>
